import {Component, Input} from '@angular/core';
import {Clipboard} from '@angular/cdk/clipboard';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
    selector: 'course-support-pin-dialog',
    templateUrl: './pinDialog.component.html',
    styleUrls: ['./pinDialog.component.scss'],
})
export class PinDialogComponent {
    @Input() pinCode: string;

    constructor(
        private snackBar: MatSnackBar,
        private clipboard: Clipboard
    ) {}

    copy() {
        this.clipboard.copy(this.pinCode);

        this.snackBar.open(
            $localize `:@@support.pinCopied:PIN-code has been copied to the clipboard!`,
            '',
            {
                duration: 5000,
                panelClass: ['successSnackbar']
            }
        );
    }
}

